module.exports = __webpack_public_path__ + "img/case3.90ad0c39.png";